module.exports = __webpack_public_path__ + "img/f5.88b41617.png";